import { createContext, useState, useCallback } from 'react';
import { useAsyncMonthlyLeaseTransactions } from '../LeaseDataTab/LeaseDataTabForm/hooks';
import useCustomEvent from '../../hooks/useCustomEvent';
import {
  LEASE_UPLOADED,
  LEASE_EXECUTED,
  LEASE_CANCELLED,
  VOUCHERS_UPDATED,
} from './customEvents';

export const LeaseDataTabContext = createContext({
  allMonthlyTransactions: [],
  updateTransactionsList: () => {},
  setSelectedLeaseId: () => {},
  selectedLeaseId: null,
});

export const LeaseDataTabProvider = ({ leaseId, children }) => {
  const [selectedLeaseId, setSelectedLeaseId] = useState(leaseId);

  const { allMonthlyTransactions, updateTransactionsList } =
    useAsyncMonthlyLeaseTransactions(selectedLeaseId);

  const handleTransactionsUpdate = useCallback(() => {
    updateTransactionsList();
  }, [updateTransactionsList]);

  useCustomEvent({
    eventKey: LEASE_UPLOADED,
    listener: handleTransactionsUpdate,
  });

  useCustomEvent({
    eventKey: VOUCHERS_UPDATED,
    listener: handleTransactionsUpdate,
  });

  useCustomEvent({
    eventKey: LEASE_EXECUTED,
    listener: handleTransactionsUpdate,
  });

  useCustomEvent({
    eventKey: LEASE_CANCELLED,
    listener: handleTransactionsUpdate,
  });

  return (
    <LeaseDataTabContext.Provider
      value={{
        allMonthlyTransactions,
        updateTransactionsList,
        setSelectedLeaseId,
        selectedLeaseId,
      }}
    >
      {children}
    </LeaseDataTabContext.Provider>
  );
};
